import { createFileRoute } from '@tanstack/react-router';
import { JobPipelinesPage } from './index';

export const Route = createFileRoute('/_dashboard/dashboard/settings/job-pipelines/$id')({
  component: JobPipelinesPage,
});
